import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import {
  INSURANCE_REQUEST_VALUES,
  CAR_INSURANCE_TYPE,
  HOW_TO_GET_CAR,
  IS_LEASE_TERM_MORE_THAN_1_YEAR,
  IS_CAR_FOR_WELFARE,
} from "const";
import { currentUserSelector } from "store/current_user"
import { isPermitted } from 'utils/utils';
import VehicleInspectionCertImage from "components/VehicleInspectionCertImage"
import { getStylesBackgroundColor} from 'views/Detail/components';
import { getStylesLabelColorLine} from 'views/Detail/components';

const VehicleDetails = (props) => {
  const { vehicle, insuranceType, lockedBy } = props;

  // 金額のカンマ区切り
  const formatter = new Intl.NumberFormat('ja-JP');

  const currentUser = useSelector(currentUserSelector)

  return (
    <Card>
      <CardHeader
        title="車両入替"
        className={getStylesBackgroundColor(insuranceType)}
      />
      <CardContent className={styles.cardContent}>
        <div className={styles.vehicleInformation}>
          <Grid container spacing={5}>
            <Grid item xs={2}>
              <div>
                <p className={getStylesLabelColorLine(insuranceType)}>車両保険の付帯</p>
                <p className={styles.text}>
                  {vehicle?.carInsuranceRequest
                    ? INSURANCE_REQUEST_VALUES[vehicle.carInsuranceRequest]
                    : "-"}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div>
                <p className={getStylesLabelColorLine(insuranceType)}>車両保険タイプ</p>
                <p className={styles.text}>
                  {vehicle?.carInsuranceType
                    ? CAR_INSURANCE_TYPE[vehicle.carInsuranceType]
                    : "-"}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div>
                <p className={getStylesLabelColorLine(insuranceType)}>変更後のお車の購入金額</p>
                <p className={styles.text}>
                  {vehicle?.price || vehicle?.price === 0
                    ? formatter.format(vehicle.price) + "万円"
                    : "-"}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div>
                <p className={getStylesLabelColorLine(insuranceType)}>お車の取得方法</p>
                <p className={styles.text}>
                  {vehicle?.howToGetCar
                    ? HOW_TO_GET_CAR[vehicle.howToGetCar]
                    : "-"}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div>
                <p className={getStylesLabelColorLine(insuranceType)}>リース期間</p>
                <p className={styles.text}>
                  {vehicle?.isLeaseTermMoreThan1Year
                    ? IS_LEASE_TERM_MORE_THAN_1_YEAR[
                        vehicle.isLeaseTermMoreThan1Year
                      ]
                    : "-"}
                </p>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div>
                <p className={getStylesLabelColorLine(insuranceType)}>福祉車両該当有無</p>
                <p className={styles.text}>
                  {vehicle?.isCarForWelfare
                    ? IS_CAR_FOR_WELFARE[
                        vehicle.isCarForWelfare
                      ]
                    : "-"}
                </p>
              </div>
            </Grid>
            <Grid item xs={6}>
              <VehicleInspectionCertImage
                title="変更後の車検証"
                s3FileName={vehicle.s3FileName}
                isPrintButtonDisabled={!isPermitted(currentUser, lockedBy)}
                customClassName="labelColorLine"
              />
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
};

VehicleDetails.propTypes = {
  className: PropTypes.string,
};

export default VehicleDetails;
